import React from 'react';
import {
    DOMNode,
    domToReact,
    Element,
    HTMLReactParserOptions,
} from 'html-react-parser';
import Button from '@frontend/jetlend-web-ui/src/ui/inputs/Button/Button';
import Image from '@app/components/Image/Image';
import styles from './WpPostContent.module.scss';
import blockquoteIcon from '@app/icons/wp-post/blockquote.svg';
import dataRoleIcon from '@app/icons/wp-post/data-role.svg';
import ExpandableItem from '@app/components/ExpandableItem/ExpandableItem';
import InvestorsLeadForm from '@app/features/investors/InvestorsLeadForm/InvestorsLeadForm';
import BorrowersLeadForm from '@app/features/borrowers/BorrowersLeadForm/BorrowersLeadForm';

const headingLevels = ['h2', 'h3'];

// опции парсера для WpPostContent
export const options: HTMLReactParserOptions  = {
    replace(domNode, id) {
        const {
            attribs,
            name,
            children,
        } = domNode as Element;
        // Если нет аттрибутов то пропускаем элемент
        if (!attribs) {
            return;
        }

        if (headingLevels.includes(name)) {
            return (
                React.createElement(name, { id }, domToReact(children as DOMNode[], options))
            );
        }

        // Обработчик блока Цитаты
        if (name === 'blockquote') {
            return (
                <blockquote>
                    <Image
                        alt=""
                        src={blockquoteIcon}
                    />
                    {domToReact(children as DOMNode[], options)}
                </blockquote>
            );
        }

        // Обработчик блока Кнопки
        if (attribs?.['data-role'] === 'jetlend/button') {
            const href = attribs['data-link'];
            const isExternalLink = href.includes('https://');

            return (
                <div className={styles['button-container']}>
                    <Button
                        type={attribs['data-type'] as any}
                        size={attribs['data-size'] as any}
                        href={href}
                        external={isExternalLink}
                        noSpacing
                    >
                        {domToReact(children as DOMNode[], options)}
                    </Button>
                </div>
            );
        }

        // Обработчик выделенного блока
        if (attribs?.['data-role'] === 'jetlend/block') {
            return (
                <div data-role="jetlend/block">
                    <Image
                        alt=""
                        src={dataRoleIcon}
                    />
                    {domToReact(children as DOMNode[], options)}
                    <Image
                        alt=""
                        src={dataRoleIcon}
                    />
                </div>
            );
        }

        // Обработчик спойлера
        if (attribs?.['data-role'] === 'jetlend/spoiler') {

            const title = children.find((value: Element) => value.attribs?.['data-role'] === 'title') as Element;
            const content = children.find((value: Element) => value.attribs?.['data-role'] === 'content') as Element;

            if (!title && !content) {
                return;
            }

            return (
                <div data-role="jetlend/spoiler">
                    <ExpandableItem
                        title={title
                            ? domToReact(title.children as DOMNode[], options)
                            : 'Подробнее'
                        }
                    >
                        {content
                            ? domToReact(content.children as DOMNode[], options)
                            : ''
                        }
                    </ExpandableItem>
                </div>
            );
        }
        // Обработчик таблиц
        if (name === 'table') {
            return (
                <div data-role="table">
                    <table>
                        {domToReact(children as DOMNode[], options)}
                    </table>
                </div>
            );
        }
        // Обработчик встроенного видео
        if (name === 'iframe') {
            const {
                width,
                height,
            } = attribs;

            const parsedWidth = parseInt(width);
            const parsedHeight = parseInt(height);
            const aspectRatio = parsedWidth / parsedHeight;

            return (
                <iframe
                    {...attribs}
                    className={styles['embed-content']}
                    style={{ aspectRatio }}
                />
            );
        }
        // Обработчик лид-формы Инвестора
        if (attribs?.['data-role'] === 'jl-lead-form-investor') {
            return <InvestorsLeadForm />;
        }
        // Обработчик лид-формы Заемщика
        if (attribs?.['data-role'] === 'jl-lead-form-borrower') {
            return <BorrowersLeadForm />;
        }
        // Обработчик встроенного изображения
        if (attribs && name === 'img') {
            const {
                width,
                height,
                src,
                alt,
            } = attribs;

            const parsedWidth = parseInt(width);
            const parsedHeight = parseInt(height);
            const aspectRatio = parsedWidth / parsedHeight;

            return (
                <div className={styles['image-wrapper']} style={{ aspectRatio }}>
                    <Image
                        fill
                        src={src}
                        alt={alt}
                    />
                </div>
            );
        }
    },
};